export enum PicklistSelectMode {
    SINGLE = 'SINGLE',
    MULTIPLE = 'MULTIPLE'
}
